var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank-chart"},[_c('MyChart',{attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }